import { useTranslation } from 'react-i18next'

import { useFormatShelfLife } from '@widgets/product-detail/hooks/useFormatShelfLife'

import { Product, ProductAttribute } from '@shared/generated'

import styles from './About.module.scss'

interface AttributeItemProps {
  attr: ProductAttribute;
}

function AttributeItem (props: AttributeItemProps) {
  const { attr } = props

  return (
    <div className={styles.about__subitem}>
      <h3 className={styles['about__subitem-name']}>{attr?.name}</h3>
      <span className={styles['about__subitem-line']}></span>
      <span className={styles['about__subitem-value']}>{attr?.value}</span>
    </div>
  )
}

interface AboutProductProps {
  product: Product;
}


export default function About (props: AboutProductProps) {
  const shellLife = useFormatShelfLife()
  const { t: tp } = useTranslation('product')

  const { product } = props

  const infoItems: ProductAttribute[] = [
    ...(product.attributes?.filter(Boolean) ?? []) as ProductAttribute[],
    ...([
      { name: tp('product.brand'), value: product.brand?.name },
      { name: tp('product.manufacturer'), value: product.productProperties?.manufacturerName },
      { name: tp('product.country'), value: product.productProperties?.country },
      { name: tp('product.volume'), value: product.pkg },
      { name: tp('product.article'), value: product.xid },
    ].filter((item) => !!item.value) as ProductAttribute[]),
  ]

  const storageItems: ProductAttribute[] = ([
    {
      name: tp('storage.maxPeriod'),
      value: product.productProperties?.shelfLife
        ? shellLife(product.productProperties.shelfLife as string)
        : null,
    },
  ].filter((item) => !!item.value) as ProductAttribute[])

  return (
    <div className={styles.about}>
      {product.ingredients && (
        <div className={styles.about__item}>
          <h3 className={styles.about__title}>{tp('product.ingredients')}</h3>
          <p className={styles.about__desc}>{product.ingredients}</p>
        </div>
      )}

      {!!infoItems.length && (
        <div className={styles.about__item}>
          <h3 className={styles.about__title}>{tp('product.info')}</h3>
          {infoItems.map((item) => (
            <AttributeItem attr={item} key={item.name} />
          ))}
        </div>
      )}

      {!!storageItems.length && (
        <div className={styles.about__item}>
          <h3 className={styles.about__title}>
            {tp('storage.conditions')}
          </h3>
          {storageItems.map((item) => (
            <AttributeItem attr={item} key={item.name} />
          ))}
        </div>
      )}
    </div>
  )
}
